import React from 'react';
import { format } from 'date-fns';

const HourCellAndroid = ({ events, day, hour, esFeriado, horarioInfo, onEventClick, onDateClick }) => {
  const handleClick = () => {
    if (!horarioInfo.laborable || esFeriado) return;
    const [h, m] = hour.split(':').map(Number);
    const date = new Date(day);
    date.setHours(h, m, 0, 0);
    onDateClick(date, h);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        width: '100%',
        height: '100%',
        border: '1px solid #e5e7eb',
        background: esFeriado ? '#ffebee' : horarioInfo.laborable ? '#f9fafb' : '#e5e7eb',
        padding: 4,
        overflow: 'hidden',
        cursor: horarioInfo.laborable && !esFeriado ? 'pointer' : 'not-allowed',
      }}
    >
      {events.slice(0, 2).map(event => (
        <div
          key={event.id}
          onClick={(e) => {
            e.stopPropagation();
            onEventClick(event);
          }}
          style={{
            background: event.color,
            color: 'white',
            padding: '2px 4px',
            borderRadius: 4,
            fontSize: 10,
            marginBottom: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {event.title}
        </div>
      ))}
      {events.length > 2 && (
        <div style={{ fontSize: 10, color: '#666' }}>+{events.length - 2} más</div>
      )}
    </div>
  );
};

export default HourCellAndroid;